import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";
export const SET_EXTERNAL_USER_EMAIL_PREFERENCE =
  "SET_EXTERNAL_USER_EMAIL_PREFERENCE";

export const service = async (data) => {
  const options: object = {
    url:
      `/Api/ExternalUser/SetExternalUserEmailPreference?isDailyDigestEnabled=` +
      data.isDailyDigestEnabled,
    method: "GET",
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(SET_EXTERNAL_USER_EMAIL_PREFERENCE, service, mock);
